module.exports = __webpack_public_path__ + "img/hr-stone-path-inner-corner.67064d6a.png";